import React, { FC, } from 'react';
import '../style/temp.less';

export interface Props {
    dataField?: any
    index: number
}
interface SetProps {
    dataField?: any
    id?: string
    methods?: any
    selectedInfo?: any
    otherInfo?: any
}

const CustomArea: FC<Props> = ({ dataField }) => {
    return (
        <div className="preview-container" >
            CustomArea
        </div>
    )
}

export const CustomAreaSet: FC<SetProps> = ({ dataField, id }) => {

    return <div className="setting-container">
        CustomArea
    </div>
}

export default CustomArea